import gql from 'graphql-tag';
import React, { useState } from 'react';
import Validate from './Validate';
import { Box, Button, Container, Stack, TextField, Typography } from '@mui/material';
import SignInButton from './SignInButton';
import SignUpButton from './SignUpButton';
import { useDrawer } from './context/DrawerContext';

const GET_TOKEN = gql`
mutation GetToken($email:String!) {
  requestPasswordReset(email:$email)
}`
  ;

const SignInGetToken = props => {
  const [email, setEmail] = useState('');
  let {openDrawer} = useDrawer();

  document.title = `navscout - Sign In`;

 const handleGetToken = (e) => {
    e.preventDefault();
    getToken(props.client, email, openDrawer);
  };

  return (
    <Container sx={{ textAlign: 'left' }}>
      <Typography variant="h5" component="h1" gutterBottom>
        Forgot your password?
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        No problem. Enter your email below and we'll send you a secure, one-time sign-in token.
      </Typography>
      
      <form onSubmit={handleGetToken}>
        <Stack spacing={2}>
          <TextField
            fullWidth
            label='Email'
            name='email'
            placeholder='Email'
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <Button
            fullWidth
            type="submit"
            disabled={!Validate.notBlank(email)}
            variant='contained'
          >
            Send Me a Token
          </Button>
        </Stack>
      </form>

      <Stack direction="row" spacing={1} sx={{ mt: 3 }}>
        <SignInButton />
        <SignUpButton />
      </Stack>
    </Container>
  );
}

const getToken = (client, email, openDrawer) => {
  client.mutate({
    mutation: GET_TOKEN,
    variables: { email },
    refetchQueries: ['Account', 'Alerts', 'FindPlace', 'GetCalendar', 'Places']
  }).then(data => {
    if (!data.data.requestPasswordReset === null) {
      console.log('Request token failed');
    } else {
      openDrawer('sign-in-token');
    }
  });
}

export default SignInGetToken;